export default __webpack_public_path__ + "static/media/IMG_20190725_105158.2d5db8d3.jpg";